// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__11Q6Y","rightAdornment":"Header_rightAdornment__3yJiD"};